/** Digits only, max 8 (ddmmyyyy). */
export function dateBrDigitsOnly(value) {
  return String(value ?? '')
    .replace(/\D/g, '')
    .slice(0, 8);
}

/** Display mask dd/mm/aaaa while typing. */
export function maskDateBrDisplay(value) {
  const digits = dateBrDigitsOnly(value);
  if (!digits.length) return '';
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

/** Canonical stored value for personalized template date fields. */
export function normalizeDateBrInput(input) {
  return maskDateBrDisplay(input);
}

/**
 * Format a date value as dd/mm/aaaa.
 * Accepts ISO yyyy-mm-dd, Date objects, or already-formatted BR strings.
 */
export function formatDateBr(value) {
  if (value == null || value === '') return '';

  const s = String(value).trim();
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) return s;

  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-');
    return `${d}/${m}/${y}`;
  }

  const parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    const day = String(parsed.getDate()).padStart(2, '0');
    const month = String(parsed.getMonth() + 1).padStart(2, '0');
    const year = parsed.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return s;
}

/** Ensure date-typed personalized fields are sent as dd/mm/aaaa. */
export function formatPersonalizedFormDataDates(formData, formFields) {
  const next = { ...(formData ?? {}) };

  (formFields ?? []).forEach((field) => {
    if (field.type !== 'date') return;
    const value = next[field.id];
    if (value == null || value === '') return;
    next[field.id] = formatDateBr(value);
  });

  return next;
}
